// Thin API wrapper for Phase 2 CRUD.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

const asError = (err) => {
  const detail = err?.response?.data?.detail;
  return new Error(typeof detail === "string" ? detail : (detail?.msg || err.message || "Request failed"));
};

// ---- CLFs ----
export const CLFs = {
  list: async (params = {}) => (await http.get("/clfs", { params })).data,
  get:  async (id) => (await http.get(`/clfs/${id}`)).data,
  create: async (payload) => {
    try { return (await http.post("/clfs", payload)).data; } catch (e) { throw asError(e); }
  },
  update: async (id, payload) => {
    try { return (await http.put(`/clfs/${id}`, payload)).data; } catch (e) { throw asError(e); }
  },
  deactivate: async (id) => (await http.post(`/clfs/${id}/deactivate`)).data,
  activate:   async (id) => (await http.post(`/clfs/${id}/activate`)).data,
};

// ---- VOs ----
export const VOs = {
  list: async (params = {}) => (await http.get("/vos", { params })).data,
  create: async (payload) => {
    try { return (await http.post("/vos", payload)).data; } catch (e) { throw asError(e); }
  },
  update: async (id, payload) => {
    try { return (await http.put(`/vos/${id}`, payload)).data; } catch (e) { throw asError(e); }
  },
  deactivate: async (id) => (await http.post(`/vos/${id}/deactivate`)).data,
  activate:   async (id) => (await http.post(`/vos/${id}/activate`)).data,
};

// ---- SHGs ----
export const SHGs = {
  list: async (params = {}) => (await http.get("/shgs", { params })).data,
  create: async (payload) => {
    try { return (await http.post("/shgs", payload)).data; } catch (e) { throw asError(e); }
  },
  update: async (id, payload) => {
    try { return (await http.put(`/shgs/${id}`, payload)).data; } catch (e) { throw asError(e); }
  },
  deactivate: async (id) => (await http.post(`/shgs/${id}/deactivate`)).data,
  activate:   async (id) => (await http.post(`/shgs/${id}/activate`)).data,
};

// ---- Members ----
export const Members = {
  list: async (params = {}) => (await http.get("/members", { params })).data,
  create: async (payload) => {
    try { return (await http.post("/members", payload)).data; } catch (e) { throw asError(e); }
  },
  update: async (id, payload) => {
    try { return (await http.put(`/members/${id}`, payload)).data; } catch (e) { throw asError(e); }
  },
  deactivate: async (id) => (await http.post(`/members/${id}/deactivate`)).data,
  activate:   async (id) => (await http.post(`/members/${id}/activate`)).data,
};

// ---- Loans ----
export const Loans = {
  list: async (params = {}) => (await http.get("/loans", { params })).data,
  create: async (payload) => {
    try { return (await http.post("/loans", payload)).data; } catch (e) { throw asError(e); }
  },
  update: async (id, payload) => {
    try { return (await http.put(`/loans/${id}`, payload)).data; } catch (e) { throw asError(e); }
  },
  schedule: async (id) => (await http.get(`/loans/${id}/schedule`)).data,
};

// ---- Repayments ----
export const Repayments = {
  list: async (params = {}) => (await http.get("/repayments", { params })).data,
  get: async (id) => (await http.get(`/repayments/${id}`)).data,
  create: async (payload) => {
    try { return (await http.post("/repayments", payload)).data; } catch (e) { throw asError(e); }
  },
  reverse: async (id, payload) => {
    try { return (await http.post(`/repayments/${id}/reverse`, payload)).data; } catch (e) { throw asError(e); }
  },
};

// ---- WhatsApp reminders ----
export const Reminders = {
  status: async () => (await http.get("/whatsapp/status")).data,
  settings: async () => (await http.get("/reminders/settings")).data,
  saveSettings: async (payload) => {
    try { return (await http.put("/reminders/settings", payload)).data; } catch (e) { throw asError(e); }
  },
  build: async (payload) => {
    try { return (await http.post("/reminders/build", payload)).data; } catch (e) { throw asError(e); }
  },
  list: async (params = {}) => (await http.get("/reminders", { params })).data,
  action: async (id, action, payload) => {
    try { return (await http.post(`/reminders/${id}/${action}`, payload)).data; } catch (e) { throw asError(e); }
  },
  sendQueued: async () => {
    try { return (await http.post("/reminders/send-queued")).data; } catch (e) { throw asError(e); }
  },
};

// ---- Dashboard ----
export const Dashboard = {
  stats: async () => (await http.get("/dashboard/stats")).data,
};
